import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outlet-type-hierarchy',
  templateUrl: './outlet-type-hierarchy.component.html',
  styleUrls: ['./outlet-type-hierarchy.component.scss']
})
export class OutletTypeHierarchyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
